// New Profiler.js - Manual, session-based, hierarchical profiler for Vue 2.x

class Profiler {
    profilerEnabled = true;
    constructor() {
        this.reset();
    }

    disableProfiler() {
        this.profilerEnabled = false;
    }

    enableProfiler() {
        this.profilerEnabled = true;
    }

    reset() {
        this.sessionActive = false;
        this.sessionLabel = null;
        this.sessionStart = 0;
        this.callStack = [];
        this.events = [];
    }

    start(label = 'session') {
        this.reset();
        if (!this.profilerEnabled) return;
        this.sessionActive = true;
        this.sessionLabel = label;
        this.sessionStart = performance.now();
        console.log(`[Profiler] START: ${label}`);
    }

    end() {
        if (!this.sessionActive) return;
        const sessionEnd = performance.now();
        this.sessionActive = false;
        const totalTime = sessionEnd - this.sessionStart;
        console.log(`[Profiler] END: ${this.sessionLabel} (total: ${totalTime.toFixed(2)} ms)`);
        this._printSummary(totalTime);
        this.reset();
    }

    // Call this at the start and end of any tracked function/block
    enter(type, context, name) {
        if (!this.sessionActive) return;
        const now = performance.now();
        const entry = {
            type,
            context,
            name,
            start: now,
            end: null,
            children: [],
            parent: this.callStack.length ? this.callStack[this.callStack.length - 1] : null
        };
        if (entry.parent) entry.parent.children.push(entry);
        this.callStack.push(entry);
    }

    exit() {
        if (!this.sessionActive || !this.callStack.length) return;
        const now = performance.now();
        const entry = this.callStack.pop();
        entry.end = now;
        this.events.push(entry);
    }

    // Helper for manual instrumentation
    profileBlock(type, context, name, fn) {
        this.enter(type, context, name);
        try {
            return fn();
        } finally {
            this.exit();
        }
    }

    // Print a hierarchical summary of all calls, exclusive time, and total session time
    _printSummary(totalTime) {
        // Print the tree recursively
        function printTree(entry, indent = 0) {
            const pad = '  '.repeat(indent);
            const name = `${entry.type}:${entry.context}:${entry.name}`;
            // Exclusive time = total - sum(children)
            let exclusive = (entry.end - entry.start);
            for (const child of entry.children) {
                exclusive -= (child.end - child.start);
            }
            console.log(`${pad}${name}: exclusive=${exclusive.toFixed(2)} ms, total=${(entry.end-entry.start).toFixed(2)} ms`);
            for (const child of entry.children) {
                printTree(child, indent + 1);
            }
        }
        // Print all top-level events
        const flat = this.events.filter(e => !e.parent);
        console.group(`[Profiler] Hierarchical Summary for ${this.sessionLabel}`);
        for (const entry of flat) printTree(entry, 0);
        console.log(`Total session time: ${totalTime.toFixed(2)} ms`);
        console.groupEnd();
    }
}

const profiler = new Profiler();
export default profiler;